import type { IChangeFlightEligibilityClasses } from "@b2bportal/core-types";
import type { IChangeFlightEligibilityData } from "@tenant/flights";
import { Loading } from "@tenant/ui";

export interface IChangeFlightEligibilityLoadingProps {
  classes?: Partial<
    IChangeFlightEligibilityClasses & {
      loadingText: string;
    }
  >;
  copy: IChangeFlightEligibilityData["copy"];
}

export const ChangeFlightEligibilityLoading = (
  props: IChangeFlightEligibilityLoadingProps
) => {
  const { classes, copy } = props;

  return (
    <div className={classes?.modalContent}>
      <Loading />
      <div className={classes?.loadingText}>{copy.loadingPolicyMsg}</div>
    </div>
  );
};
